import React, { useState, useEffect } from 'react';
import { 
  History, 
  MessageSquare,
  Calendar,
  ArrowRight,
  Mail,
  Loader,
  RefreshCw,
  AlertCircle,
  Send,
  Edit,
  User,
  ImageIcon,
  Camera,
  Plus,
  Mic,
  Users,
  Clock,
  Flag,
  FileText,
  Settings,
  Activity,
  Zap,
  X,
  Eye,
  CheckCircle,
  Truck,
  UserPlus,
  UserMinus,
  Info,
  File,
  Target,
  Hash,
  Type,
  AlignLeft,
  MapPin,
  Star,
  Timer,
  Building,
  Phone,
  Globe,
  Tag,
  ChevronUp,
  Download,
} from 'lucide-react';
import api from '../../api';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose}></div>
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto relative z-10">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Détails de l'activité</h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        <div className="p-4">
          {children}
        </div>
      </div>
    </div>
  );
};

const formatFileSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} octets`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / 1048576).toFixed(1)} Mo`;
};

const NotificationItem = ({ 
  notification, 
  getUserName, 
  getUserInitials, 
  getUserColor, 
  getTimeAgo, 
  getActivityIcon,
  getActivityColor,
  parseMessage,
  onShowDetails
}) => {
  const userName = getUserName(notification);
  const userInitials = getUserInitials(userName);
  const userColor = getUserColor(userName);
  const timeAgo = getTimeAgo(notification.created_at);
  const parsedMessage = parseMessage(notification.message, notification.type, notification.file);  const isSystemUser = !notification.utilisateur || userName === 'Système';
  const [loading, setLoading] = useState(true);


  const truncateText = (text, maxLength = 60) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };
  const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('fr-FR', options);
};

  const shouldShowViewButton = (text, maxLength = 60) => {
    return text && text.length > maxLength;
  };
  <style>{`
  .image-preview {
    max-width: 300px;
    max-height: 200px;
    object-fit: contain;
    background-color: #f5f5f5;
    border-radius: 4px;
    border: 1px solid #e5e5e5;
  }
  /* ... autres styles ... */
`}</style>



const downloadFileToComputer = (fileUrl, fileName) => {
  // Nettoyer le nom de fichier
  const cleanFileName = fileName
    .replace(/[^a-z0-9\-_\.]/gi, '_')
    .substring(0, 50);
  
  // Créer l'élément de téléchargement
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = cleanFileName;
  link.style.display = 'none';
  
  document.body.appendChild(link);
  link.click();
  
  // Nettoyer après 1 seconde
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }, 1000);
};


const downloadFile = async (fileUrl, fileName = 'document') => {
  // Déclarer finalFileName en haut de la fonction pour qu'elle soit disponible partout
  let finalFileName = fileName;

  try {
    // 1. Normalisation du nom de fichier
    // Si pas d'extension, on la devine depuis l'URL
    if (!finalFileName.includes('.')) {
      const urlParts = fileUrl.split('/').pop().split('.');
      if (urlParts.length > 1) {
        const ext = urlParts.pop().split('?')[0].toLowerCase();
        finalFileName = `${finalFileName}.${ext}`;
      } else {
        // Extension par défaut si impossible à déterminer
        finalFileName = `${finalFileName}.download`;
      }
    }

    // 2. Tentative avec fetch API (pour les CORS et les blobs)
    const response = await fetch(fileUrl, {
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    // 3. Création du lien de téléchargement
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = finalFileName;
    link.style.display = 'none';

    // 4. Déclenchement du téléchargement
    document.body.appendChild(link);
    link.click();

    // 5. Nettoyage
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }, 100);

    return true;
    
  } catch (error) {
    console.error('Download failed:', error);
    
    // Fallback pour les cas où fetch échoue (CORS, etc.)
    try {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = finalFileName; // Maintenant finalFileName est accessible
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 100);
      return true;
    } catch (fallbackError) {
      console.error('Fallback download failed:', fallbackError);
      return false;
    }
  }
};
const downloadAnyFile = async (fileUrl, fileName = 'file') => {
  // Normalisation du nom de fichier
  const cleanFileName = fileName
    .replace(/[^a-zA-Z0-9_\u0400-\u04FF\-\.]/g, '') // Caractères spéciaux
    .replace(/\s+/g, '_')
    .replace(/\.+/g, '.');

  // Extraction de l'extension depuis l'URL si absente
  let finalName = cleanFileName;
  if (!finalName.includes('.')) {
    const urlExt = fileUrl.split('.').pop().split(/[?#]/)[0].toLowerCase();
    const validExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'txt', 'zip'];
    finalName += validExts.includes(urlExt) ? `.${urlExt}` : '.bin';
  }

  try {
    // Solution optimale pour Cloudinary
    const downloadUrl = fileUrl.includes('cloudinary.com') 
      ? `${fileUrl}?fl_attachment=${encodeURIComponent(finalName)}`
      : fileUrl;

    // Tentative avec fetch (meilleure pour les gros fichiers)
    const response = await fetch(downloadUrl, { 
      mode: 'no-cors',
      cache: 'no-cache'
    });

    if (response.ok || response.type === 'opaque') { // Gère no-cors
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = finalName;
      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }, 100);
      
      return true;
    }
    throw new Error('Fetch failed');
    
  } catch (error) {
    console.warn('Fallback to direct download:', error);
    // Solution de repli
    const link = document.createElement('a');
    link.href = `${fileUrl}?${fileUrl.includes('?') ? '&' : '?'}download=${finalName}`;
    link.download = finalName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => document.body.removeChild(link), 100);
    
    return false;
  }
};

  return (
    <div className="flex items-start space-x-3 px-4 py-4 hover:bg-gray-50 transition-colors">
       
      <div className="flex-shrink-0 relative">
        <div className={`w-10 h-10 ${isSystemUser ? 'bg-gray-500' : userColor} rounded-full flex items-center justify-center text-white font-medium text-sm shadow-sm`}>
          {isSystemUser ? <Settings className="w-5 h-5" /> : userInitials}
        </div>
        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-white rounded-full border-2 border-white shadow-sm">
          <div className={`w-full h-full ${getActivityColor(parsedMessage.type)} rounded-full flex items-center justify-center`}>
            {getActivityIcon(parsedMessage.type)}
          </div>
        </div>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center space-x-2">
            <div className="flex items-baseline gap-2 min-w-0">
  <span className="text-sm font-medium text-gray-900 truncate flex items-center">
    {userName}
    {isSystemUser && (
      <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-600">
        <Settings className="w-2.5 h-2.5 mr-0.5" />
        Système
      </span>
    )}
  </span>
  <span className="text-xs text-gray-500 whitespace-nowrap">
    {getTimeAgo(notification.created_at)}
  </span>
</div>
            {notification.type === 'bug' && (
              <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded-full">
                Création
              </span>
            )}
            {notification.type === 'confirmation_test' && (
              <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 text-xs font-medium rounded-full">
                Confirmation
              </span>
            )}
            {notification.type === 'system_change' && (
              <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs font-medium rounded-full">
                Automatique
              </span>
            )}
          </div>


        </div>

        <div className="mb-2">
          {/* Afficher le titre */}
          {parsedMessage.title && (
            <div className="text-sm font-medium text-gray-800 mb-1 flex items-start gap-2">
              <span className="flex-1">
                {truncateText(parsedMessage.title)}
              </span>
              {shouldShowViewButton(parsedMessage.title) && (
                <button
                  onClick={() => onShowDetails(notification, parsedMessage)}
                  className="flex-shrink-0 p-1 hover:bg-gray-200 rounded transition-colors"
                  title="Voir les détails"
                >
                  <Eye className="w-3 h-3 text-gray-500" />
                </button>
              )}
            </div>
          )}
          
          {/* Afficher la description */}
          {parsedMessage.description && (
            <div className="text-sm text-gray-600 flex items-start gap-2">
              <span className="flex-1">
                {truncateText(parsedMessage.description)}
              </span>
              {shouldShowViewButton(parsedMessage.description) && (
                <button
                  onClick={() => onShowDetails(notification, parsedMessage)}
                  className="flex-shrink-0 p-1 hover:bg-gray-200 rounded transition-colors"
                  title="Voir les détails"
                >
                  <Eye className="w-3 h-3 text-gray-500" />
                </button>
              )}
            </div>
          )}
        </div>

        {/* Détails spécifiques selon le type d'activité */}
        {parsedMessage.type === 'status_change' && parsedMessage.details && (
          <div className="flex items-center space-x-2 text-sm mt-2">
            <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
              {parsedMessage.details.from}
            </span>
            <ArrowRight className="w-3 h-3 text-gray-400" />
            <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
              {parsedMessage.details.to}
            </span>
          </div>
        )}

        {parsedMessage.type === 'stage_change' && parsedMessage.details && (
          <div className="flex items-center space-x-2 text-sm mt-2">
            <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
              {parsedMessage.details.from || 'Vide'}
            </span>
            <ArrowRight className="w-3 h-3 text-gray-400" />
            <span className="px-2 py-1 bg-indigo-100 text-indigo-700 rounded text-xs font-medium">
              {parsedMessage.details.to}
            </span>
          </div>
        )}

        {parsedMessage.type === 'field_change' && parsedMessage.details && (
          <div className="flex items-center space-x-2 text-sm mt-2 p-2 bg-blue-50 rounded border-l-2 border-blue-200">
            <Edit className="w-4 h-4 text-blue-600" />
            <div>
              <span className="font-medium text-blue-800">{parsedMessage.details.field}</span>
              <div className="flex items-center space-x-2 mt-1">
                <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
                  {parsedMessage.details.from || 'Vide'}
                </span>
                <ArrowRight className="w-3 h-3 text-gray-400" />
                <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
                  {parsedMessage.details.to}
                </span>
              </div>
            </div>
          </div>
        )}

        {parsedMessage.type === 'date_change' && parsedMessage.details && (
          <div className="flex items-center space-x-2 text-sm mt-2 p-2 bg-green-50 rounded border-l-2 border-green-200">
            <Calendar className="w-4 h-4 text-green-600" />
            <div>
              <span className="font-medium text-green-800">{parsedMessage.details.field}</span>
              <div className="text-xs text-gray-600 mt-1">
                {parsedMessage.details.from ? (
                  <div className="flex items-center space-x-2">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
                      {parsedMessage.details.from}
                    </span>
                    <ArrowRight className="w-3 h-3 text-gray-400" />
                    <span className="px-2 py-1 bg-green-100 text-green-700 rounded text-xs font-medium">
                      {parsedMessage.details.to}
                    </span>
                  </div>
                ) : (
                  <span className="font-medium text-green-700">{parsedMessage.details.to}</span>
                )}
              </div>
            </div>
          </div>
        )}

        {parsedMessage.type === 'priority_change' && parsedMessage.details && (
          <div className="flex items-center space-x-2 text-sm mt-2">
            <Flag className="w-4 h-4 text-orange-500" />
            <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
              {parsedMessage.details.from}
            </span>
            <ArrowRight className="w-3 h-3 text-gray-400" />
            <span className={`px-2 py-1 rounded text-xs font-medium ${
              parsedMessage.details.to === 'Élevée' ? 'bg-red-100 text-red-700' :
              parsedMessage.details.to === 'Moyenne' ? 'bg-orange-100 text-orange-700' :
              'bg-gray-100 text-gray-700'
            }`}>
              {parsedMessage.details.to}
            </span>
          </div>
        )}

        {parsedMessage.type === 'dev_removed' && parsedMessage.details && (
          <div className="flex items-start space-x-2 text-sm mt-2 p-2 bg-red-50 rounded border-l-2 border-red-200">
            <UserMinus className="w-4 h-4 text-red-600 mt-0.5" />
            <div>
              <div className="font-medium text-red-800 mb-1">
                Développeur retiré
              </div>
              {parsedMessage.details.developers && parsedMessage.details.developers.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {parsedMessage.details.developers.map((dev, index) => (
                    <span key={index} className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs">
                      {dev}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {parsedMessage.type === 'dev_added' && parsedMessage.details && (
          <div className="flex items-start space-x-2 text-sm mt-2 p-2 bg-purple-50 rounded border-l-2 border-purple-200">
            <UserPlus className="w-4 h-4 text-purple-600 mt-0.5" />
            <div>
              <div className="font-medium text-purple-800 mb-1">
                Développeur ajouté
              </div>
              {parsedMessage.details.developers && parsedMessage.details.developers.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {parsedMessage.details.developers.map((dev, index) => (
                    <span key={index} className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs flex items-center">
                      <User className="w-3 h-3 mr-1" />
                      {dev}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {parsedMessage.type === 'creation' && (
          <div className="flex items-center space-x-2 text-sm mt-2 p-2 bg-green-50 rounded border-l-2 border-green-200">
            <Zap className="w-4 h-4 text-green-600" />
            <div>
              <span className="font-medium text-green-800">Nouveau ticket</span>
              <div className="text-xs text-gray-600 mt-1">
                Le ticket a été créé dans le système
              </div>
            </div>
          </div>
        )}

        {parsedMessage.type === 'confirmation' && (
          <div className="flex items-center space-x-2 text-sm mt-2 p-2 bg-emerald-50 rounded border-l-2 border-emerald-200">
            <CheckCircle className="w-4 h-4 text-emerald-600" />
            <div>
              <span className="font-medium text-emerald-800">Test confirmé</span>
              <div className="text-xs text-gray-600 mt-1">
                Le test de ce ticket a été validé
              </div>
            </div>
          </div>
        )}

        {parsedMessage.type === 'comment' && (
          <div className="flex items-center space-x-2 text-sm mt-2 p-2 bg-blue-50 rounded border-l-2 border-blue-200">
            <MessageSquare className="w-4 h-4 text-blue-600" />
            <div>
              <span className="font-medium text-blue-800">Commentaire ajouté</span>
            </div>
          </div>
        )}
      </div>
{parsedMessage.type === 'image' && (
  <div className="mt-4 space-y-3">
    {/* Conteneur image avec ombre et bordure subtile */}
    <div className="relative group rounded-xl overflow-hidden border border-gray-200 bg-white shadow-sm hover:shadow-md transition-all duration-300">
      {/* Overlay de chargement - seulement si loading est true */}
      {loading && (
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/95 backdrop-blur-sm transition-opacity duration-300">
          <div className="flex flex-col items-center space-y-2">
            <div className="w-8 h-8 border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin" />
            <span className="text-sm font-medium text-gray-500">Chargement de l'image</span>
          </div>
        </div>
      )}

      {/* Conteneur image avec ratio préservé */}
      <div className="aspect-w-16 aspect-h-9 bg-gray-50 flex items-center justify-center">
        {/* Message d'erreur - caché par défaut */}
        <div className="hidden error-message p-6 text-center w-full"></div>
        
        <img
          src={parsedMessage.fileUrl}
          alt={parsedMessage.description || `Image envoyée`}
          className="w-full h-auto max-h-[480px] object-contain transition-opacity duration-300"
          loading="lazy"
          onLoad={() => setLoading(false)}
          onError={(e) => {
            const img = e.target;
            img.style.display = 'none';
            
            const errorDiv = img.previousElementSibling;
            errorDiv.classList.remove('hidden');
            errorDiv.classList.add('block', 'bg-gray-50');
            
            errorDiv.innerHTML = `
              <div class="mx-auto bg-red-100 rounded-full w-12 h-12 flex items-center justify-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 class="text-sm font-medium text-gray-700">Image non disponible</h4>
              <p class="text-xs text-gray-500 mt-1">${parsedMessage.description || 'Impossible de charger cette image'}</p>
            `;
          }}
          style={{ opacity: loading ? 0 : 1 }}
        />
      </div>

      {/* Info-bulle au survol - seulement si l'image est chargée */}
      {!loading && (
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="space-y-1">
            <p className="text-sm text-white font-medium line-clamp-1">
              {parsedMessage.description || 'Fichier image'}
            </p>
            <div className="flex items-center text-xs text-white/80 space-x-2">
              <span>{notification.file?.size ? formatFileSize(notification.file.size) : 'Taille inconnue'}</span>
              <span>•</span>
              <span>{new Date(notification.createdAt).toLocaleDateString()}</span>
            </div>
          </div>
        </div>
      )}
    </div>

    {/* Actions - seulement si l'image est chargée */}
    {!loading && (
      <div className="flex justify-end space-x-3">
        <button 
          onClick={() => window.open(parsedMessage.fileUrl, '_blank')}
          className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          Aperçu
        </button>
<button
  onClick={() => downloadFile(parsedMessage.fileUrl, parsedMessage.file_name || 'document')}
  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all"
>
  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
  Télécharger
</button>
      </div>
    )}
  </div>
)}
{parsedMessage.type === 'document_upload' && (
    <div className="mt-4 space-y-1.5 w-full">
      <div className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors shadow-xs">
        <div className="flex-shrink-0 p-2 bg-blue-100 rounded-lg">
          <FileText className="w-5 h-5 text-blue-600" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {parsedMessage.file_name
              ?.replace(/\(\d+\)/g, '')
              ?.replace(/\s+/g, ' ')
              ?.replace(/\s*\.\w+$/, '')
              ?.trim() || 'Document'}
          </p>
          <div className="flex items-center gap-2 mt-0.5">
            <span className="text-xs text-gray-500">
              {parsedMessage.fileSize ? formatFileSize(parsedMessage.fileSize) : 'Taille inconnue'}
            </span>
            <span className="text-gray-300">•</span>
            <span className="text-xs text-blue-500 font-medium">{parsedMessage.file_name  || 'Nom inconnue'}</span>
          </div>
        </div>

        <div className="flex gap-1">

          <button 
            onClick={() => downloadAnyFile(
                        parsedMessage.fileUrl, 
                        parsedMessage.file_name || `document_${new Date().getTime()}`
                      )}           
          className="p-2 text-gray-500 hover:text-blue-600 rounded-full hover:bg-blue-100 transition-colors"
          >
            <Download className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  )}
    </div>
  );
};

const TicketHistory = ({ ticketId = "95", userId = 1, apiUrl = "https://easytask.easysystem.cloud/api/easy-tasks-b/api" }) => {
  const [notifications, setNotifications] = useState({
    history: [],
    total_count: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newMessage, setNewMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [showDocumentOptions, setShowDocumentOptions] = useState(false);
  const [utilisateurId, setUtilisateurId] = useState(null);

    useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setUtilisateurId(parseInt(user.id, 10));
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);

  


  useEffect(() => {
    if (ticketId) {
      fetchNotifications();
    }
  }, [ticketId]);

const fetchNotifications = async () => {
  try {
    setLoading(true);
    setError(null);

    const { data } = await api.get(`/notifications/ticket/${ticketId}`);
    setNotifications(data || { history: [], total_count: 0 });

  } catch (err) {
    console.error('Erreur lors du chargement des notifications:', err);
    setError("Impossible de charger l'historique du ticket");
  } finally {
    setLoading(false);
  }
};

const sendMessage = async () => {
  if (!newMessage.trim() || sending) return;

  try {
    setSending(true);
    setError(null);

    await api.post('/notifications/ticket', {
      message: newMessage,
      utilisateur_id: userId,
      ticket_id: ticketId,
    });

    setNewMessage('');
    await fetchNotifications();

  } catch (err) {
    console.error("Erreur lors de l'envoi du message:", err);
    setError("Échec de l'envoi du message");
  } finally {
    setSending(false);
  }
};

  
const uploadToLaravel = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const res = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data.url; // URL publique renvoyée par Laravel
};
const handleUploadDocuments = async (e, ticketId) => {
  const files = e.target.files;
  if (!files || !files.length || !ticketId) return;


  setUploading(true);
  setUploadError(null);

  try {
    const uploadedDocuments = [];


    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const url = await uploadToLaravel(file);

      uploadedDocuments.push({
        document_url: url,
        action: 1,
        document_name: file.name,
      });
    }

    // Requête vers l’API Laravel
    await api.post(`/tickets/${ticketId}`, {
      modifier: utilisateurId ,
      documents: uploadedDocuments,
      
    });

    // Optionnel : feedback utilisateur
    await fetchNotifications();
    toast.success("Documents envoyés avec succès.");
  } catch (error) {
    console.error("Erreur lors de l'envoi des documents :", error);
    setUploadError("Échec de l'envoi des documents.");
  } finally {
    setUploading(false);
  }
};







const handleUploadGallery = async (e) => {
  const files = e.target.files;
  if (!files.length) return;

  setUploading(true);
  setUploadError(null);

  try {
    const uploadedImages = [];


    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        console.warn(`❌ Fichier non-image ignoré: ${file.name}`);
        continue; // ignore les non-images
      }

      console.log(`🖼️ Upload de l’image: ${file.name}`);
      const url = await uploadToLaravel(file);
      console.log("✅ URL Cloudinary image:", url);

      uploadedImages.push({
        document_url: url,
        action: 1,
      });

      await api.post("/notifications/ticket", {
        message: `Image ajoutée via galerie: ${file.name}`,
        file: url,
        utilisateur_id: utilisateurId,
        ticket_id: ticketId,
      });
    }

    const putPayload = {
      modifier: utilisateurId,
      documents: uploadedImages,
    };

    console.log("📤 post /tickets avec payload galerie:", putPayload);

    await api.post(`/tickets/${ticketId}`, putPayload);

    await fetchNotifications();
    console.log("✅ Galerie upload terminée");
  } catch (error) {
    console.error("❌ Erreur d'upload galerie:", error);
    setUploadError("Échec de l'envoi des images.");
  } finally {
    setUploading(false);
    e.target.value = ""; // reset l'input
  }
};






  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const handleShowDetails = (notification, parsedMessage) => {
    setModalData({ notification, parsedMessage });
  };

  const getUserInitials = (userName) => {
    if (!userName) return 'U';
    const names = userName.split(' ');
    if (names.length >= 2) {
      return (names[0][0] + names[1][0]).toUpperCase();
    }
    return userName.substring(0, 2).toUpperCase();
  };

  const getUserColor = (userName) => {
    if (!userName) return 'bg-gray-500';
    
    const colors = [
      'bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-orange-500',
      'bg-pink-500', 'bg-indigo-500', 'bg-teal-500', 'bg-red-500',
      'bg-cyan-500', 'bg-emerald-500', 'bg-violet-500', 'bg-rose-500'
    ];
    
    const hash = userName.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);
    
    return colors[Math.abs(hash) % colors.length];
  };

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMinutes < 1) {
      return 'À l\'instant';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}min`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h`;
    } else if (diffInDays < 7) {
      return `${diffInDays}j`;
    } else {
      return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    }
  };

  const getUserName = (notification) => {
    if (notification.utilisateur?.nom_complet) {
      return notification.utilisateur.nom_complet;
    }
    
    if (notification.utilisateur?.nom && notification.utilisateur?.prenom) {
      return `${notification.utilisateur.nom} ${notification.utilisateur.prenom}`;
    }
    
    if (notification.utilisateur?.nom) {
      return notification.utilisateur.nom;
    }
    
    return 'Système';
  };

  const parseMessage = (message, type, file) => {

    // Filtrer les changements de statut identiques
    const statusChangePattern = /modifié Statut de "([^"]*)" vers "([^"]*)"/;
    const statusMatch = message.match(statusChangePattern);
    if (statusMatch && statusMatch[1] === statusMatch[2]) {
      return null;
    }
    
  //   if (file && message && message.startsWith("Image ajoutée:")) {
    
  //   return {
  //     type: 'image',
  //     description: null,
  //     fileUrl: file // URL de l'image
  //   };
  // }


  //  if (file && message && message.startsWith("Document uploadé:")) {
  //   return {
  //     type: 'document_upload',
  //     description: message.replace("Document uploadé:", "").trim(),
  //     fileUrl: file
  //   };
  // }
  let filename = null;

if ((message.includes("ajouté le document") || message.startsWith("Document ajouté:")) && file) {
  const matches = message.match(/document:\s*(.+\.\w+)/i); // Extrait le nom complet
  const rawFilename = matches ? matches[1] : null;

  filename = rawFilename ? decodeURIComponent(rawFilename.trim()) : null;
  const extension = filename?.split('.').pop()?.toLowerCase();

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
  const isImage = imageExtensions.includes(extension);

  return {
    type: isImage ? 'image' : 'document_upload',
    description: null,
    fileUrl: file,
    file_name: filename || 'Document inconnu',
  };
}


 if (file && message && message.startsWith("Image ajoutée:")) {
    return {
      type: 'image',
      description: null,
      fileUrl: file,
      file_name: filename || 'Document inconnu',
    };
  }

if ((message.includes("ajouté le document") || message.startsWith("Document ajouté:")) && file) {
  const matches = message.match(/document:\s*(.+\.\w+)/i); // Extrait le nom du fichier
  const filename = matches ? matches[1] : null;
  const extension = filename?.split('.').pop()?.toLowerCase();

  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

  const isImage = imageExtensions.includes(extension);

  return {
    type: isImage ? 'image' : 'document_upload', // ✅ C'est ici la clé
    description: null,
    fileUrl: file,
    file_name: filename || 'Document inconnu',
  };
}




    // Création de ticket
    if (message === "Ticket créé" || type === "demande") {
      return {
        type: 'creation',
        title: 'Ticket créé',
        description: 'Un nouveau ticket a été créé dans le système'
      };
    }

    // Commentaire simple
    if (type === "commentaire" || (!message.includes("modifié") && !message.includes("déplacé") && !message.includes("supprimé") && !message.includes("ajouté"))) {
      return {
        type: 'comment',
        title: message,
        description: null
      };
    }

    // Changement d'étape
    const stagePattern = /déplacé le ticket de l'étape "([^"]*)" vers "([^"]*)"/;
    const stageMatch = message.match(stagePattern);
    if (stageMatch) {
      return {
        type: 'stage_change',
        title: 'Étape modifiée',
        description: `Le ticket a été déplacé vers l'étape "${stageMatch[2]}"`,
        details: {
          from: stageMatch[1] || 'Vide',
          to: stageMatch[2]
        }
      };
    }

    // Suppression de développeur
    const removeDevPattern = /supprimé (\d+) développeur du ticket : (.+)/;
    const removeDevMatch = message.match(removeDevPattern);
    if (removeDevMatch) {
      return {
        type: 'dev_removed',
        title: 'Développeur retiré',
        description: `${removeDevMatch[1]} développeur${parseInt(removeDevMatch[1]) > 1 ? 's ont été retirés' : ' a été retiré'}`,
        details: {
          developers: removeDevMatch[2].split(', ')
        }
      };
    }

    // Ajout de développeur - Pattern corrigé
    const addDevPattern = /ajouté (\d+) développeur au ticket : (.+)/;
    const addDevMatch = message.match(addDevPattern);
    if (addDevMatch) {
      const developersText = addDevMatch[2].trim();
      // Diviser par virgule et nettoyer chaque nom
      const developers = developersText.split(',').map(dev => dev.trim());
      
      return {
        type: 'dev_added',
        title: 'Développeur ajouté',
        description: `${addDevMatch[1]} développeur${parseInt(addDevMatch[1]) > 1 ? 's ajoutés' : ' ajouté'}`,
        details: {
          developers: developers
        }
      };
    }

    // Patterns pour les modifications de champs génériques
const fieldChangePatterns = [
  // Dates - Pattern corrigé
  {
    pattern: /modifié (Date de début technique|Deadline technique|Deadline client|Date de livraison|Date de début|Date de fin) de "([^"]*)" vers "([^"]*)"/,
    type: 'date_change'
  },
  {
    pattern: /défini (Date de début technique|Deadline technique|Deadline client|Date de livraison|Date de début|Date de fin): "([^"]*)"/,
    type: 'date_change'
  },
  // AJOUT : Pattern pour "Non définie" -> date
  {
    pattern: /(Date de début technique|Deadline technique|Deadline client|Date de livraison|Date de début|Date de fin) Non définie définie à "([^"]*)"/,
    type: 'date_change'
  },
  // AJOUT : Pattern alternatif pour les définitions de dates
  {
    pattern: /défini (Date de début technique|Deadline technique|Deadline client|Date de livraison|Date de début|Date de fin) à "([^"]*)"/,
    type: 'date_change'
  },
  // Priorité
  {
    pattern: /modifié (Priorité|priorité) de "([^"]*)" vers "([^"]*)"/,
    type: 'priority_change'
  },
  // Statut
  {
    pattern: /modifié (Statut|statut) de "([^"]*)" vers "([^"]*)"/,
    type: 'status_change'
  },
  // Champs texte
  {
    pattern: /modifié (Nom|nom|Titre|titre|Description|description|Notes|notes|Commentaire|commentaire) de "([^"]*)" vers "([^"]*)"/,
    type: 'field_change'
  },
  // Champs numériques
  {
    pattern: /modifié (ID|id|Numéro|numéro|Version|version|Estimation|estimation) de "([^"]*)" vers "([^"]*)"/,
    type: 'field_change'
  },
  // Champs de sélection
  {
    pattern: /modifié (Type|type|Catégorie|catégorie|Environnement|environnement|Plateforme|plateforme) de "([^"]*)" vers "([^"]*)"/,
    type: 'field_change'
  },
  // Assignation
  {
    pattern: /modifié (Assigné à|assigné à|Responsable|responsable|Développeur|développeur) de "([^"]*)" vers "([^"]*)"/,
    type: 'field_change'
  },
  // Autres champs
  {
    pattern: /modifié ([^"]+) de "([^"]*)" vers "([^"]*)"/,
    type: 'field_change'
  }
];

// Tester chaque pattern
for (const { pattern, type: patternType } of fieldChangePatterns) {
  const match = message.match(pattern);
  if (match) {
    // Logique améliorée pour gérer les différents formats
    let fieldName, fromValue, toValue;
    
    if (message.includes('Non définie définie à')) {
      // Format: "Deadline client Non définie définie à "2024-12-31""
      fieldName = match[1];
      fromValue = 'Non définie';
      toValue = match[2];
    } else if (message.includes('défini') && !message.includes('modifié')) {
      // Format: "défini Deadline client: "2024-12-31"" ou "défini Deadline client à "2024-12-31""
      fieldName = match[1];
      fromValue = null;
      toValue = match[2];
    } else {
      // Format standard: "modifié Deadline client de "ancienne" vers "nouvelle""
      fieldName = match[1];
      fromValue = match[2];
      toValue = match[3];
    }

    const isDefinition = fromValue === null || fromValue === 'Non définie';

    return {
      type: patternType,
      title: `${fieldName} ${isDefinition ? 'définie' : 'modifiée'}`,
      description: `${fieldName} a été ${isDefinition ? 'définie' : 'modifiée'}`,
      details: {
        field: fieldName,
        from: fromValue,
        to: toValue
      }
    };
  }
}

    // Message générique
    return {
      type: 'generic',
      title: message,
      description: null
    };

 
    
  };

  const getActivityIcon = (type) => {
    const icons = {
      creation: Zap,
      comment: MessageSquare,
      stage_change: ArrowRight,
      priority_change: Flag,
      status_change: Activity,
      dev_added: UserPlus,
      dev_removed: UserMinus,
      date_change: Calendar,
      field_change: Edit,
      confirmation: CheckCircle,
      generic: Info,
      document_upload: FileText,
    };
    
    const IconComponent = icons[type] || Info;
    return <IconComponent className="w-2 h-2 text-white" />;
  };

  const getActivityColor = (type) => {
    const colors = {
      creation: 'bg-green-500',
      comment: 'bg-blue-500',
      stage_change: 'bg-indigo-500',
      priority_change: 'bg-orange-500',
      status_change: 'bg-red-500',
      dev_added: 'bg-purple-500',
      dev_removed: 'bg-red-500',
      date_change: 'bg-emerald-500',
      field_change: 'bg-cyan-500',
      confirmation: 'bg-emerald-600',
      generic: 'bg-gray-500',
      document_upload: 'bg-blue-500',
    };
    
    return colors[type] || 'bg-gray-500';
  };

  const getDateKey = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
    
    if (dateOnly.getTime() === todayOnly.getTime()) {
      return "Aujourd'hui";
    } else if (dateOnly.getTime() === yesterdayOnly.getTime()) {
      return "Hier";
    } else {
      return date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
      });
    }
  };

  const groupNotificationsByDate = (notifications) => {
    if (!Array.isArray(notifications)) {
      return [];
    }
    
    const groups = {};
    
    // Filtrer les notifications nulles (changements de statut identiques)
    const filteredNotifications = notifications.filter(notification => {
      const parsed = parseMessage(notification.message, notification.type);
      return parsed !== null;
    });
    
    filteredNotifications.forEach(notification => {
      const dateKey = getDateKey(notification.created_at);
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(notification);
    });

    return Object.entries(groups).sort((a, b) => {
      if (a[0] === "Aujourd'hui") return -1;
      if (b[0] === "Aujourd'hui") return 1;
      
      if (a[0] === "Hier") return -1;
      if (b[0] === "Hier") return 1;
      
      return new Date(b[1][0].created_at) - new Date(a[1][0].created_at);
    });
  };

  

  if (loading) {
    return (
      <div className="bg-white h-96 border border-gray-200 rounded-lg shadow-sm">
        <div className="p-6 flex items-center justify-center h-full">
          <div className="flex items-center space-x-3 text-gray-500">
            <Loader className="w-5 h-5 animate-spin" />
            <span>Chargement des activités...</span>
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="bg-white h-96 border border-gray-200 rounded-lg shadow-sm">
        <div className="p-6">
          <div className="flex items-center space-x-3 text-red-600 mb-4">
            <AlertCircle className="w-5 h-5" />
            <span>{error}</span>
          </div>
          <button
            onClick={fetchNotifications}
            className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="bg-white flex flex-col border border-gray-200 rounded-lg shadow-sm h-full">
      {/* Header */}
      <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 rounded-t-lg flex-shrink-0">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <History className="w-5 h-5 text-gray-600" />
            <h3 className="font-medium text-gray-900">
              Historique du ticket #{ticketId}
            </h3>
          </div>
          <div className="text-sm text-gray-500">
            {notifications.total_count} activité
            {notifications.total_count > 1 ? 's' : ''}
          </div>
        </div>
      </div>

      {/* Zone scrollable */}
      <div className="flex-1 overflow-y-auto">
        {notifications.history.length === 0 ? (
          <div className="p-8 text-center flex flex-col items-center justify-center h-full">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <History className="w-8 h-8 text-gray-400" />
            </div>
            <p className="text-gray-500 font-medium">Aucune activité</p>
            <p className="text-sm text-gray-400 mt-1">Les activités apparaîtront ici</p>
          </div>
        ) : (
          <div className="space-y-0">
            {groupNotificationsByDate(notifications.history).map(([date, dayNotifications]) => (
              <div key={date}>
                <div className="bg-gray-100 px-4 py-2 text-center border-b border-gray-200 sticky top-0 z-10">
                  <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
                    {date}
                  </span>
                </div>

                <div className="divide-y divide-gray-100">
                  {dayNotifications
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .map((notification) => (
                      <NotificationItem
                        key={notification.id}
                        notification={notification}
                        getUserName={getUserName}
                        getUserInitials={getUserInitials}
                        getUserColor={getUserColor}
                        getTimeAgo={getTimeAgo}
                        getActivityIcon={getActivityIcon}
                        getActivityColor={getActivityColor}
                        parseMessage={parseMessage}
                        onShowDetails={handleShowDetails}
                      />
                    ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Zone message fixée */}
<div className="bg-[#f0f2f5] border-t border-[#e9edef] flex-shrink-0">
  {/* Upload Progress Indicator - Floating */}
  {uploading && (
    <div 
      className="fixed bottom-24 left-1/2 transform -translate-x-1/2 bg-[#333]/90 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm flex items-center shadow-xl animate-[fadeIn_0.3s_ease-out]"
    >
      <Loader className="w-4 h-4 mr-2 animate-spin" />
      <span>Envoi en cours...</span>
      <span className="ml-2 text-xs opacity-80">0%</span>
    </div>
  )}

  {/* Attachment Picker - Animated */}
  {showDocumentOptions && (
    <div className="animate-[slideUp_0.2s_ease-out] px-4 pt-3 pb-2 bg-white border-b border-[#e9edef]">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-medium text-[#3b4a54]">Envoyer un fichier</h3>
        <button 
          onClick={() => setShowDocumentOptions(false)}
          className="text-[#667781] hover:text-[#128c7e] transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div className="flex space-x-6 overflow-x-auto pb-2 scrollbar-hide">
        {/* Gallery Option */}
        <label className="flex flex-col items-center cursor-pointer active:opacity-80 min-w-[60px] group">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mb-1 transition-all group-active:scale-95 bg-[#e3f2fc] group-hover:bg-[#d4eaf9]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#128c7e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
          </div>
          <span className="text-xs text-[#54656f] group-hover:text-[#128c7e] transition-colors">Galerie</span>
          <input type="file"
            accept="image/*"
            multiple
            onChange={(e) => handleUploadDocuments(e, ticketId)}
            className="hidden"
            disabled={uploading} />
        </label>
        
        {/* Document Option */}
        <label className="flex flex-col items-center cursor-pointer active:opacity-80 min-w-[60px] group">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mb-1 transition-all group-active:scale-95 bg-[#fee9e8] group-hover:bg-[#fddad8]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f15c6d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </div>
          <span className="text-xs text-[#54656f] group-hover:text-[#f15c6d] transition-colors">Document</span>
          <input 
            type="file"
            multiple
            onChange={(e) => handleUploadDocuments(e, ticketId)}
            className="hidden"
            disabled={uploading}
          />
        </label>
        

      </div>
    </div>
  )}

  {/* Input Area */}
  <div className="p-3">
    <div className="flex items-end space-x-2">
      {/* Attachment Button */}
      <button 
        onClick={() => setShowDocumentOptions(!showDocumentOptions)}
        className={`w-10 h-10 flex items-center justify-center rounded-full transition-all ${
          showDocumentOptions 
            ? "bg-[#128c7e]/10 text-[#128c7e] rotate-45"
            : "text-[#54656f] hover:bg-gray-100"
        }`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
        </svg>
      </button>
      
      {/* Message Input */}
      <div className="flex-1 bg-white rounded-full border border-[#e9edef] focus-within:border-[#128c7e]/50 focus-within:shadow-sm transition-all">
        <textarea
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Écrivez un message..."
          className="w-full px-4 py-2 bg-transparent text-sm resize-none focus:outline-none max-h-32 placeholder-[#667781] text-[#3b4a54] scrollbar-hide"
          rows="1"
          disabled={sending}
          style={{
            minHeight: '40px',
            lineHeight: '20px',
          }}
        />
      </div>
      
      {/* Send Button */}
      <button
        onClick={newMessage.trim() ? sendMessage : () => {}}
        disabled={sending || !newMessage.trim()}
        className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
          newMessage.trim() 
            ? "bg-[#128c7e] text-white hover:bg-[#0e7d6e] active:scale-95"
            : "text-[#54656f] hover:bg-gray-100"
        }`}
      >
        {sending ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="animate-spin">
            <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
          </svg>
        ) : newMessage.trim() ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
            <line x1="9" y1="9" x2="9.01" y2="9"></line>
            <line x1="15" y1="9" x2="15.01" y2="9"></line>
          </svg>
        )}
      </button>
    </div>
  </div>

  {/* Animation keyframes - inline */}
  <style>{`
    @keyframes fadeIn {
      from { opacity: 0; transform: translate(-50%, 10px); }
      to { opacity: 1; transform: translate(-50%, 0); }
    }
    @keyframes slideUp {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .scrollbar-hide::-webkit-scrollbar {
      display: none;
    }
    .image-preview {
    max-width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    background-color: #f5f5f5;
    margin-top: 8px;
  }
  .image-container {
    position: relative;
    margin-top: 8px;
  }
  .image-loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 4px;
  }
  `}</style>
</div>
    </div>
    </>
  );  
}

export default TicketHistory;